export const UtmSource = 'docs_site' as const;

export const UtmMediumSharedDoc = 'quick_share' as const;

export enum UtmCampaign {
  DocsMdPageFooter = 'docs_md_page_footer',
  DocsApiPageFooter = 'docs_api_page_footer',
  DocsLoginPageFooter = 'docs_login_page_footer',
  ErrorPage = 'error_page',
}

export const UtmKey = {
  Source: 'utm_source',
  Medium: 'utm_medium',
  Campaign: 'utm_campaign',
  Content: 'utm_content',
} as const;
